var $189a8638fc03e199$exports = {};
const $189a8638fc03e199$var$currentYearEl = document.getElementById('current-year');
if ($189a8638fc03e199$var$currentYearEl) $189a8638fc03e199$var$currentYearEl.textContent = String(new Date().getFullYear());


//# sourceMappingURL=main.10d85fa7.js.map
